import { render, staticRenderFns } from "./TheTitle.vue?vue&type=template&id=06c1701e&scoped=true&"
import script from "./TheTitle.vue?vue&type=script&lang=js&"
export * from "./TheTitle.vue?vue&type=script&lang=js&"
import style0 from "./TheTitle.vue?vue&type=style&index=0&id=06c1701e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1701e",
  null
  
)

export default component.exports